import type { RouteRecordRaw } from "vue-router";

export const promotionRoutes: RouteRecordRaw[] = [
  {
    path: "promotion",
    name: "promotion",
    component: () => import("@/pages/product-promotion/index.vue")
  }
];
